import { Box, Paper, Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PrivateWrapper from '../../layout/Private';
import ActivateChannelForm from '../../components/channel/ActivateChannel';
import { getChannelByFilmmaker } from '../../services/Channels';
import { channelsStatus } from '../../config/Constants';
import ChannelVideosPage from '../../components/channel/ChannelPrograms';
import AppLoader from '../../components/AppLoader';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MyChannel = () => {
  const pageName = 'My Channel';

  const [dataLoaded, setDataLoaded] = useState(false);
  const [channel, setChannel] = useState(null);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [tabValue, setTabValue] = useState('programs');

  useEffect(() => {
    if (tabValue === 'programs') {
      setActiveTab(0);
    }
  }, [tabValue]);

  useEffect(() => {
    setDataLoaded(false);
    getChannelByFilmmaker()
      .then((res) => {
        setChannel(res.data.channel);
        setDataLoaded(true);
      })
      .catch(() => {
        setDataLoaded(true);
      });
  }, [reloadCounter]);

  return (
    <PrivateWrapper pageName={pageName}>
      {!dataLoaded && <AppLoader height="50vh" />}
      {((channel && channel.status !== channelsStatus.ACTIVE) || (!channel && dataLoaded)) && (
        <ActivateChannelForm
          channel={channel}
          onSuccess={() => setReloadCounter((prev) => prev + 1)}
        />
      )}
      {channel && channel.status === channelsStatus.ACTIVE && dataLoaded && (
        <>
          <Box component={Paper} mt={2} p={2} minHeight="80vh">
            <Box>
              <Tabs
                value={tabValue}
                aria-label="tabs"
                indicatorColor="primary"
                onChange={(_, v) => {
                  setTabValue(v);
                }}
              >
                <Tab value="programs" label="Programs" {...a11yProps(0)} />
              </Tabs>
            </Box>
            <Box>
              <TabPanel value={activeTab} index={0}>
                <ChannelVideosPage channel={channel} />
              </TabPanel>
            </Box>
          </Box>
        </>
      )}
    </PrivateWrapper>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

export default MyChannel;
